/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { Dropdown, Form, ButtonGroup, Button } from "react-bootstrap";
import { components } from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faMultiply } from "@fortawesome/free-solid-svg-icons";

export const filterConfig = [
	{ key: "is_railroadable", label: "Rail", options: ["Railroadable", "Not Railroadable"] },
	{ key: "is_seamable", label: "Seam", options: ["Seamable", "Not Seamable"] },
	// { key: "fire_retardant", label: "FR", options: ["Fire Retardant", "Non Fire Retardant"] },
	// { key: "style", label: "Style", options: ["Decorative", "Standard"] },
	{ key: "opacity", label: "Opacity", options: ["0%", "1%","3%","5%","10%","20%", "45%", "Light Filtering", "Translucent"] }
];

const Filters = (props: any) => {
	const { selectedFilters, setSelectedFilters } = props;
	const handleChange = (filterLabel: string, value: string) => {
		setSelectedFilters((prev) => ({
			...prev,
			[filterLabel]: prev[filterLabel] === value ? null : value
		}));
	};

	const handleClear = (filterLabel: string) => {
		setSelectedFilters((prev) => ({
			...prev,
			[filterLabel]: null
		}));
	};

	return (
		<div className="bg-body border-light rounded-bottom">
			<div
				style={{
					position: "sticky",
					top: 0,
					zIndex: 1,
					padding: "0.5rem",
					borderBottom: "1px solid var(--bs-border-color)",
					display: "flex",
					gap: "0.5rem",
					justifyContent: "start",
					flexWrap: "wrap"
				}}
			>
				{filterConfig.map(({ label, options }) => {
					const isActive = selectedFilters[label];
					return (
						<Dropdown key={label} as={ButtonGroup} className="no-dropdown-arrow">
							{isActive && (
								<Button
									variant="outline-primary"
									size="sm"
									onClick={() => handleClear(label)}
									className="rounded-start "
									style={{
										display: "flex",
										alignItems: "center",
										padding: "0.25rem 0.5rem",
									}}
								>
									<FontAwesomeIcon icon={faMultiply} />
								</Button>
							)}
							<Dropdown.Toggle
								split={!!isActive}
								variant={isActive ? "success" : "light"}
								size="sm"
								style={{
									display: "flex",
									alignItems: "center",
									justifyContent: "space-between",
									gap: "0.25rem",
									padding: "0.25rem 0.5rem",
									borderRadius: isActive ? "0 0.375rem 0.375rem 0" : "0.375rem",
									color: isActive ? "white" : undefined
								}}
							>
								{isActive || label}
								<FontAwesomeIcon icon={faChevronDown} />
							</Dropdown.Toggle>
							<Dropdown.Menu>
								{options.map((opt) => (
									<Dropdown.Item
										key={opt}
										onClick={() => handleChange(label, opt)}
										as="div"
										style={{ cursor: "pointer" }}
									>
										<Form.Check
											type="radio"
											name={label}
											label={opt}
											readOnly
											checked={selectedFilters[label] === opt}
										/>
									</Dropdown.Item>
								))}
							</Dropdown.Menu>
						</Dropdown>
					);
				})}
			</div>
			<components.MenuList {...props} />
		</div>
	);
};

export default Filters;
